import React from "react";
import PropTypes from "prop-types";
import AtomHed from "components/source/atoms/atom-hed";
import AtomLinkButton from "components/source/atoms/atom-link-button";
import AtomFullWidthButton from "components/source/atoms/atom-full-width-button";
import Datepicker from "components/source/new_taxonomy/datepicker";

const defaultDuration = "4";
const eightDayDuration = "8";

class GridTopFiltersDate extends React.Component {
  static propTypes = {
    dateOptions: PropTypes.shape({
      blackoutDays: PropTypes.arrayOf(PropTypes.string).isRequired,
      dateEnd: PropTypes.string.isRequired,
      dateStart: PropTypes.string.isRequired,
    }).isRequired,
    ctaText: PropTypes.string,
    deliveryCutoffs: PropTypes.array,
    hedText: PropTypes.string,
    message: PropTypes.string,
    messageTwo: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onClickBrowse: PropTypes.func.isRequired,
    onClickBrowseSubscription: PropTypes.func.isRequired,
    workingFilters: PropTypes.object,
  };

  state = {
    duration: this.props?.workingFilters?.duration ?? defaultDuration,
    date: this.props?.workingFilters?.date,
  };

  componentDidUpdate(prevProps) {
    const prevDate = prevProps?.workingFilters?.date;
    const date = this.props?.workingFilters?.date;
    const prevDuration = prevProps?.workingFilters?.duration;
    const duration = this.props?.workingFilters?.duration;

    if (prevDate !== date || prevDuration !== duration) {
      this.setState({ date, duration });
    }
  }

  onChange = e => {
    const { name } = e;
    this.setState({
      date: name,
    });

    if (this.props.onChange) {
      this.props.onChange();
    }
  };

  onClickSwitchDuration = () => {
    const newDuration = this.state.duration === defaultDuration ? eightDayDuration : defaultDuration;
    this.setState({
      duration: newDuration,
    });
  };

  onClickBrowse = () => {
    const { date, duration } = this.state;
    this.props.onClickBrowse({ duration, date });
  };

  durationSwitchText = () => {
    if (this.state.duration !== defaultDuration) {
      return `Rent for 4 days instead?`;
    }
    return `Rent for 8 days instead?`;
  };

  render() {
    const fourDayCopy = "a 4-day";
    const eightDayCopy = "an 8-day";
    const currentDurationCopy = this.state.duration === defaultDuration ? fourDayCopy : eightDayCopy;

    const dekText = "Select a date 1 to 2 days prior to your event.";
    const subDekText = `This is ${currentDurationCopy} rental. `;

    const clickBrowseText = this.state.date ? "Save" : "Close";

    return (
      <div className="grid-top-filters-date">
        <AtomHed text={this.props.hedText} />
        <div className="atom-dek">{dekText}</div>
        <div className="atom-dek">
          {subDekText}
          <button className="duration-switch" onClick={this.onClickSwitchDuration} data-test-id="duration-switch-test">
            {this.durationSwitchText()}
          </button>
        </div>
        <div className="grid-top-filters__content">
          <Datepicker
            blackoutDays={this.props.dateOptions?.blackoutDays}
            dateEnd={this.props.dateOptions?.dateEnd}
            dateStart={this.props.dateOptions?.dateStart}
            duration={this.state.duration}
            date={this.state.date}
            deliveryCutoffs={this.props.deliveryCutoffs}
            onChange={this.onChange}
            name="filters[date]"
            idSuffix=""
          />
          {this.props.message && (
            <div className="datepicker_message">
              <span dangerouslySetInnerHTML={{ __html: this.props.message }} />
              <br />
              <span dangerouslySetInnerHTML={{ __html: this.props.messageTwo }} />
            </div>
          )}
          <div className="grid-top-filters__buttons" data-test-id="date-picker-save">
            <AtomFullWidthButton
              buttonText={this.props.ctaText ? this.props.ctaText : clickBrowseText}
              onClick={this.onClickBrowse}
            />
          </div>
          <AtomLinkButton className="underline" onClick={this.props.onClickBrowseSubscription}>
            I&apos;m looking to rent with subscription
          </AtomLinkButton>
        </div>
      </div>
    );
  }
}

export default GridTopFiltersDate;
